const RegisterBlockVB = () => {
  return (
    <div
      id="cadastrar"
      className="w-screen py-[140px] lg:py-[130px] bg-[#F0F1F2] justify-center items-center gap-[120px] inline-flex"
    >
      <div className="w-full max-w-[85rem] px-6 flex flex-col lg:flex-row justify-center items-start gap-5 lg:gap-[7.5rem] pb-[80px] lg:pb-0">
        <div className="flex-[2] md:max-w-[23.563rem] h-full flex flex-col justify-between items-center md:items-start gap-8 w-full">
          <div className="p-2.5 flex-col justify-start items-center md:items-start gap-2.5 flex">
            <div className="text-[#696969] font-normal leading-[17px] hidden md:block">
              Parceria
            </div>
            <div className="self-stretch text-black text-[28.62px] text-center md:text-left font-light leading-10 lg:pt-4">
              Veja como é fácil aproveitar o benefício
            </div>
          </div>
        </div>

        <div className="flex-[3] flex flex-col justify-center items-center gap-2 w-full">
          <div className="w-full flex flex-col md:flex-row justify-between items-center md:items-start gap-5 lg:gap-10 py-5 lg:py-10 md:border-b border-gray-300">
            <div className="w-[300px] md:flex items-start">
              <span className="text-[#eb0028] pr-4 text-xl font-bold">1</span>
              <p className="text-black text-xl font-bold text-center md:text-left">
                Análise da conta de luz
              </p>
            </div>
            <div className="w-full max-w-[27rem]">
              <p className="text-secondary-text font-normal text-center md:text-left leading-normal">
                O primeiro passo é preencher as informações solicitadas no
                portal associado e enviar sua conta de energia para análise da
                Thopen. Desta forma será elaborada uma proposta ajustada ao seu
                perfil de consumo.
              </p>
            </div>
          </div>

          <div className="w-full flex flex-col md:flex-row justify-between items-center md:items-start gap-5 lg:gap-10 py-5 lg:py-10 md:border-b border-gray-300">
            <div className="w-[300px] md:flex items-start">
              <span className="text-[#eb0028] pr-4 text-xl font-bold">2</span>
              <p className="text-black text-xl font-bold text-center md:text-left">
                Aceite da proposta e contrato
              </p>
            </div>
            <div className="w-full max-w-[27rem]">
              <p className="text-secondary-text font-normal text-center md:text-left leading-normal">
                O segundo passo é acessar a proposta através do portal exclusivo
                para associados. Após revisar, basta aceitar e assinar o
                contrato para garantir sua adesão ao benefício Thopen TIM.
              </p>
            </div>
          </div>

          <div className="w-full flex flex-col md:flex-row justify-between items-center md:items-start  gap-5 lg:gap-10 py-5 lg:py-10 md:border-b border-gray-300">
            <div className="w-[300px] md:flex items-start">
              <span className="text-[#eb0028] pr-4 text-xl font-bold">3</span>
              <p className="text-black text-xl font-bold text-center md:text-left">
                Processo de adesão
              </p>
            </div>
            <div className="w-full max-w-[27rem]">
              <p className="text-secondary-text font-normal text-center md:text-left leading-normal">
                Após a assinatura do contrato, será iniciado o processo de
                adesão com a sua concessionária de energia. O prazo para
                conclusão dessa etapa pode variar de 60 a 90 dias e você pode
                acompanhar o progresso pelo portal do associado ou WhatsApp.
              </p>
            </div>
          </div>

          <div className="w-full flex-col md:flex-row flex justify-between items-center md:items-start  gap-5 lg:gap-10 pt-10">
            <div className="w-[300px] md:flex items-start">
              <span className="text-[#eb0028] pr-4 text-xl font-bold">4</span>
              <p className="text-black text-xl font-bold text-center md:text-left">
                Adesão concluída
              </p>
            </div>
            <div className="w-full max-w-[27rem]">
              <p className="text-secondary-text font-normal text-center md:text-left leading-normal">
                Com a adesão finalizada, você está pronto para começar a
                economizar na sua conta de energia! Além disso, terá acesso
                completo às informações de economia, seus boletos, histórico de
                faturamento e configurações de pagamento através do portal do
                associado.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterBlockVB;
